export enum ErrorCodesEnum {
    SUCCESS = '0000',
    PHONE_REQUESTED = '1001',
    CUSTOMER_REGISTERED = '1002',
    INVALID_REQUEST = '1003',
    NOT_FOUND = '1004',
    /** Registration succeeded; user must verify OTP before login completes */
    OTP_VERIFICATION_REQUIRED = '1005',
}
